<div class="chip-filters" *ngIf="chips.length">
  <pa-chip
    *ngFor="let chip of chips; trackBy: trackByKey"
    [label]="chip.label"
    [maxLabelLength]="35"
    [removable]="isChipRemovable(chip)"
    (remove)="handleRemove(chip.key)"
    (chipClick)="handleClick(chip.key)"
  ></pa-chip>
</div>

